import { MathHelper } from "./../helpers/mathHelper";

export class CoerceFormatValueConverter {
  toView(value: number, minMaxDefault: string) {
    const splitParams = minMaxDefault.split(",");

    //value = parseFloat(value.toFixed(10));

    return MathHelper.coerceValue(
      value,
      Number(splitParams[0]),
      Number(splitParams[1]),
      Number(splitParams[2])
    );
  }
}
